import { render, staticRenderFns } from "./PedidoProtesto.vue?vue&type=template&id=31dd00e1&scoped=true"
import script from "./PedidoProtesto.vue?vue&type=script&lang=js"
export * from "./PedidoProtesto.vue?vue&type=script&lang=js"
import style0 from "./PedidoProtesto.vue?vue&type=style&index=0&id=31dd00e1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31dd00e1",
  null
  
)

export default component.exports